import script from "./ClubHighlightSetupExt.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubHighlightSetupExt.vue?vue&type=script&setup=true&lang=js"

import "./ClubHighlightSetupExt.vue?vue&type=style&index=0&id=004cffb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004cffb4"]])

export default __exports__